// src/utils/cloudinary.js

const CLOUDINARY_IMAGE_UPLOAD_MARKER = "/image/upload/";
const AUTO_FORMAT_QUALITY_TRANSFORMATIONS = ["f_auto", "q_auto"];
const PRODUCT_CARD_TRANSFORMATIONS = [...AUTO_FORMAT_QUALITY_TRANSFORMATIONS, "w_400"];
const BANNER_TRANSFORMATIONS = [...AUTO_FORMAT_QUALITY_TRANSFORMATIONS, "w_1280"];
const CATEGORY_TINT_TRANSFORMATIONS = ["w_200", "q_20", "f_auto"];

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function hasTransformation(url, transformation) {
  return new RegExp(`(^|[,/])${escapeRegExp(transformation)}(?=[,/])`).test(url);
}

function withCloudinaryTransformations(url, transformations) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com") || !url.includes(CLOUDINARY_IMAGE_UPLOAD_MARKER)) return url;

  const missingTransformations = transformations.filter(transformation => !hasTransformation(url, transformation));
  if (!missingTransformations.length) return url;

  return url.replace(
    CLOUDINARY_IMAGE_UPLOAD_MARKER,
    `${CLOUDINARY_IMAGE_UPLOAD_MARKER}${missingTransformations.join(",")}/`
  );
}

export function withCloudinaryAutoFormatQuality(url) {
  return withCloudinaryTransformations(url, AUTO_FORMAT_QUALITY_TRANSFORMATIONS);
}

export function withCloudinaryAutoFormatQualityList(urls = []) {
  return urls.map(withCloudinaryAutoFormatQuality);
}

export function withCloudinaryProductCardOptimization(url) {
  return withCloudinaryTransformations(url, PRODUCT_CARD_TRANSFORMATIONS);
}

export function withCloudinaryProductCardOptimizationList(urls = []) {
  return urls.map(withCloudinaryProductCardOptimization);
}

const LOGO_TRANSFORMATIONS = ["w_200", "f_auto", "q_auto"];

export function withCloudinaryLogoOptimization(url) {
  return withCloudinaryTransformations(url, LOGO_TRANSFORMATIONS);
}

export function withCloudinaryBannerOptimization(url) {
  return withCloudinaryTransformations(url, BANNER_TRANSFORMATIONS);
}

export function withCloudinaryBannerOptimizationList(urls = []) {
  return urls.map(withCloudinaryBannerOptimization);
}

export function withCloudinaryCategoryTint(url) {
  return withCloudinaryTransformations(url, CATEGORY_TINT_TRANSFORMATIONS);
}

const NOTIFICATION_HERO_TRANSFORMATIONS = ["w_800", "h_400", "c_fill", "g_auto", "f_auto", "q_auto"];

export function withCloudinaryNotificationOptimization(url) {
  return withCloudinaryTransformations(url, NOTIFICATION_HERO_TRANSFORMATIONS);
}
